<template>
	<div class="goods-form-wrapper-wholesale" @keypress.esc="cancel">
		<div class="header-sidebar mb-4 d-flex align-items-center justify-content-between" slot="header">
			<h4>
				{{ $t('sidebar.warehouse-management.newWholesale') }}
			</h4>
			<h4>№: <span>{{ currentSaleNumber }}</span>
			</h4>
			<b-button class="close-btn" @click="cancelAndClearInventory" type="button" variant="link"><i
				class="fa fa-close"></i></b-button>
		</div>
		<b-form class="form-wholesale">
			<!--<b-row>
				&lt;!&ndash;<b-col v-if="isTransfer" cols="6">
					<b-form-group
						breakpoint="lg"
						label-size="sm"
						label-cols="4"
						label-for="refName"
						class="required ml-1"
						size="sm"
					>
						<template slot="label">
							{{ $t('incomes.create.from-warehouse')}} <span class="text-danger">*</span>
						</template>
						<b-form-select
							size="sm"
							name="fromDepartment"
							v-model="formtItem.fromDepartmentId"
							v-validate="validators.fromDepartment"
						>
							<option v-for="(selectOption, indexOpt) in departments"
									:key="indexOpt"
									:value="selectOption.value"
									:disabled="selectOption.value === formtItem.toDepartmentId"
							>
								{{ selectOption.text }}
							</option>
							<template slot="first">
								<option :value="null" disabled>&#45;&#45; {{ $t('incomes.create.warehouse') }} &#45;&#45;</option>
							</template>
						</b-form-select>

					</b-form-group>
				</b-col>
				<b-col v-if="isTransfer" cols="6">
					<b-form-group
						breakpoint="lg"
						label-size="sm"
						label-cols="4"
						:label="$t('incomes.create.to-warehouse')"
						label-for="refName"
						class="required ml-1"
						size="sm"
					>
						<template slot="label">
							{{ $t('incomes.create.to-warehouse') }} <span class="text-danger">*</span>
						</template>
						<b-form-select
							size="sm"
							name="toDepartmentId"
							v-model="formtItem.toDepartmentId"
							v-validate="validators.toDepartmentId"
						>
							<option v-for="(selectOption, indexOpt) in toDepartments"
									:key="indexOpt"
									:value="selectOption.value"
									:disabled="selectOption.value === formtItem.fromDepartmentId"
							>
								{{ selectOption.text }}
							</option>
							<template slot="first">
								<option :value="null" disabled>&#45;&#45; {{ $t('incomes.create.warehouse') }} &#45;&#45;</option>
							</template>
						</b-form-select>

					</b-form-group>
				</b-col>&ndash;&gt;
				<b-col>
					<b-form-group
						breakpoint="lg"
						label-size="sm"
						label-cols="2"
						:label="$t('incomes.create.reason')"
						label-for="refName"
						label-class="ml-1"
						class="required"
						size="sm"
					>
						<b-form-input :required="true"
									  size="sm"
									  id="reason"
									  v-model="formtItem.reason"
									  :placeholder="$t('incomes.create.reason')"></b-form-input>
					</b-form-group>
				</b-col>
			</b-row>-->
			<!--<b-row>
				<b-col cols="6">
					<b-form-group
						breakpoint="lg"
						label-size="sm"
						label-cols="4"
						:label="$t('incomes.create.reg-number')"
						label-for="refName"
						label-class="ml-1"
						@focus="$event.target.select()"
						class="required"
					>
						<b-form-input :required="true"
									  size="sm"
									  id="regNumber"
									  class="ml-1"
									  v-model="formtItem.regNumber"
									  :placeholder="$t('incomes.create.reg-number')"></b-form-input>
					</b-form-group>
				</b-col>
				<b-col cols="3">
					<b-input-group size="sm">
						<masked-input v-model="formtItem.regDate"
									  mask="11-11-1111"
									  name="regDate"
									  v-validate="validators.regDate"
									  class="ml-1 form-control form-control-sm"
									  v-bind:class="{'is-invalid': !checkField('regDate')}"
									  :placeholder=" $t('incomes.create.reg-date')"/>
						<b-input-group-addon>
							<b-button size="sm" disabled>
								<i class="fa fa-calendar"></i>
							</b-button>
						</b-input-group-addon>
					</b-input-group>
				</b-col>
			</b-row>-->

			<!-- CURRENCY RATE INPUTS FOR TRANSFER BEGIN -->
			<!-- SHOW WHEN TOGGLE IS FALSE -->
			<!--<b-row v-if="isCurrenciesDifferent && !toggleCurrencyInputs">
				<b-col
					cols="5"
				>
					<b-form-group
						breakpoint="lg"
						label-size="sm"
						label-cols="5"
						:label="$t('kochirish.currencyRate')"
						label-for="toCurrencyRateId"
						label-class="ml-1"
						class="required"
					>
						<b-input-group size="sm" class="p-0">
							<b-form-input
								size="sm"
								ref="fromCurrencyRateRef1"
								id="fromCurrencyRateId"
								@focus="$event.target.select()"
								type="number"
								v-model.number="formtItem.fromCurrencyRate"
								class="ml-1"
								:disabled="!toggleCurrencyInputs"
								:placeholder="fromDepartmentForCurrency.name"></b-form-input>
							<b-input-group-addon>
								<b-button disabled size="sm">{{ fromDepartmentForCurrency.currencyName }}</b-button>
							</b-input-group-addon>
						</b-input-group>
					</b-form-group>
				</b-col>
				<b-col cols="1" style="text-align: center">
					<b-button @click="toggleCurrencyInputs = !toggleCurrencyInputs" size="md">
						<i class="fa fa-exchange"></i>
					</b-button>
				</b-col>
				<b-col
					cols="3"
				>
					<b-input-group size="sm">
						<b-form-input
							size="sm"
							ref="toCurrencyRateRef1"
							id="toCurrencyRateId"
							@focus="$event.target.select()"
							type="number"
							v-model.number="formtItem.toCurrencyRate"
							class="ml-1"
							:placeholder="toDepartmentForCurrency.name"></b-form-input>
						<b-input-group-addon>
							<b-button disabled size="sm">{{ toDepartmentForCurrency.currencyName }}</b-button>
						</b-input-group-addon>
					</b-input-group>
				</b-col>
			</b-row>-->
			<!-- SHOW WHEN TOGGLE IS TRUE -->
			<!--<b-row v-if="isCurrenciesDifferent && toggleCurrencyInputs">
				<b-col
					cols="5"
				>
					<b-form-group
						breakpoint="lg"
						label-size="sm"
						label-cols="5"
						:label="$t('kochirish.currencyRate')"
						label-for="fromCurrencyRateId"
						label-class="ml-1"
						class="required"
					>
						<b-input-group size="sm">
							<b-form-input
								size="sm"
								ref="toCurrencyRateRef2"
								id="toCurrencyRateId"
								@focus="$event.target.select()"
								type="number"
								v-model.number="formtItem.toCurrencyRate"
								class="ml-1"
								:disabled="toggleCurrencyInputs"
								:placeholder="toDepartmentForCurrency.name"></b-form-input>
							<b-input-group-addon>
								<b-button disabled size="sm">{{ toDepartmentForCurrency.currencyName }}</b-button>
							</b-input-group-addon>
						</b-input-group>
					</b-form-group>

				</b-col>
				<b-col cols="1" style="text-align: center">
					<b-button @click="toggleCurrencyInputs = !toggleCurrencyInputs" size="md">
						<i class="fa fa-exchange"></i>
					</b-button>
				</b-col>
				<b-col
					cols="3"
				>
					<b-input-group size="sm" class="p-0">
						<b-form-input
							size="sm"
							ref="fromCurrencyRateRef2"
							id="fromCurrencyRateId"
							@focus="$event.target.select()"
							type="number"
							v-model.number="formtItem.fromCurrencyRate"
							class="ml-1"
							:placeholder="fromDepartmentForCurrency.name"></b-form-input>
						<b-input-group-addon>
							<b-button disabled size="sm">{{ fromDepartmentForCurrency.currencyName }}</b-button>
						</b-input-group-addon>
					</b-input-group>
				</b-col>
			</b-row>-->
			<!-- CURRENCY RATE INPUTS FOR TRANSFER END -->

			<!--<contr-agent-select
				:label="$t('incomes.create.counteragent')"
				:options="dropDowns.counterparties.items"
				v-model="formtItem.contragentId"
				@reload="fetchList"
				@lock="$emit('lock', true)"
			></contr-agent-select>-->
			<b-row>
				<b-col cols="12" v-if="selectContrAgent">
					<p class="text-danger">Пожалуйста выберите контрагента</p>
				</b-col>
				<b-col cols="6">
					<b-form-group
						label-size="sm"
						label-cols="2"
						:label="$t('incomes.create.counteragent')+ ':'"
						class="mb-2" size="sm">
						<b-input-group class="shodowed-group">
							<b-form-select
								@change="categoryFilterChanged"
								:options="categoryOptions.items"
								:value-field="'id'"
								:text-field="'name'"
								v-model="categoryOptions.value"
								size="sm"
								id="categoryFilter">
								<template slot="first">
									<option :value="null" disabled>
										-- {{$t('contragent.search-category')}} --
									</option>
								</template>
							</b-form-select>
							<b-input-group-append>
								<b-input-group-addon>
									<b-button type="button"
											  size="sm"
											  variant="outline-default"
											  @click="clearCategoryFilter"
											  v-b-tooltip.hover :title="$t('contragent.clear')">
										<i class="fa fa-close"></i>
									</b-button>
								</b-input-group-addon>
							</b-input-group-append>
						</b-input-group>
					</b-form-group>
				</b-col>
				<b-col cols="6">
					<multiselect
						style="width: 97%;"
						v-model="contrAgent"
						:options="getContragentsForPos"
						track-by="id"
						:show-labels="false"
						:allow-empty="true"
						:loading="contragentsLoading"
						label="fullName"
						placeholder="-- Выберите контрагента --"
						class="multiselect-pricing"
					>
					</multiselect>
				</b-col>
			</b-row>
			<!--<div class="mt-1">
				<b-button class="pull-right" size="sm" v-b-toggle.collapse1 variant="light">
					<i class="fa fa-plus-circle"></i> {{ $t('incomes.create.additional') }}
				</b-button>
				<div class="clearfix"></div>
				<b-collapse id="collapse1" class="mt-2">
					<div class="mt-1">
						<b-row>
							<b-col cols="6">
								<b-form-group
									breakpoint="lg"
									label-size="sm"
									label-cols="4"
									:label="$t('incomes.create.from')"
									label-for="refName"
									class="required mb-1"
								>
									<multiselect class="pull-left with-clear" v-model="dropDowns.employees.from"
												 :options="employees"
												 :searchable="true"
												 :loading="dropDowns.product.loading"
												 :close-on-select="true"
												 label="name"
												 :selectLabel="''"
												 :deselectLabel="''"
												 track-by="id"
												 :custom-label="fullName"
												 @search-change="fetchEmployees($event)"
												 :placeholder="$t('incomes.create.select-employee')">

										<template slot="singleLabel" slot-scope="props">
											{{ props.option.firstName }}
										</template>
									</multiselect>
									<b-button class="pull-right" @click="dropDowns.employees.from = null"
											  style="position: absolute; right:6px" size="sm" variant="light">x
									</b-button>
									<div class="clearfix"></div>
								</b-form-group>
							</b-col>
							<b-col cols="6">
								<b-form-group
									breakpoint="lg"
									label-size="sm"
									label-cols="4"
									:label="$t('incomes.create.to')"
									label-for="refName"
									class="required mb-1"
								>
									<multiselect class="pull-left with-clear" v-model="dropDowns.employees.to"
												 :options="employees"
												 :searchable="true"
												 :selectLabel="''"
												 deselectLabel="''"
												 :loading="dropDowns.product.loading"
												 :close-on-select="true"
												 label="name"
												 track-by="id"
												 :custom-label="fullName"
												 @search-change="fetchList($event)"
												 :placeholder="$t('incomes.create.select-employee')">

										<template slot="singleLabel" slot-scope="props">
											{{ props.option.firstName }}
										</template>
									</multiselect>
									<b-button class="pull-right" @click="dropDowns.employees.to = null"
											  style="position: absolute; right:6px" size="sm" variant="light">x
									</b-button>
									<div class="clearfix"></div>
								</b-form-group>
							</b-col>
						</b-row>
						<b-row>
							<b-col cols="6">
								<b-form-group
									breakpoint="lg"
									label-size="sm"
									label-cols="4"
									:label="$t('incomes.create.responsible')"
									label-for="refName"
									class="required mb-1"
								>
									<multiselect class="pull-left with-clear" v-model="dropDowns.employees.responsible"
												 :options="employees"
												 :searchable="true"
												 :selectLabel="''"
												 deselectLabel="''"
												 :loading="dropDowns.product.loading"
												 :close-on-select="true"
												 label="name"
												 track-by="id"
												 :custom-label="fullName"
												 @search-change="fetchEmployees($event)"
												 :placeholder="$t('incomes.create.select-employee')">

										<template slot="singleLabel" slot-scope="props">
											{{ fullName(props.option) }}
										</template>
									</multiselect>
									<b-button class="pull-right" @click="dropDowns.employees.responsible = null"
											  style="position: absolute; right:6px" size="sm" variant="light">x
									</b-button>
									<div class="clearfix"></div>
								</b-form-group>
							</b-col>
							<b-col cols="6">
								<b-form-group
									breakpoint="lg"
									label-size="sm"
									label-cols="4"
									:label="$t('incomes.create.responsible')"
									label-for="refName"
									class="required mb-1"
								>
									<multiselect class="pull-left with-clear" v-model="dropDowns.employees.responsible2"
												 :options="employees"
												 :searchable="true"
												 :selectLabel="''"
												 deselectLabel="''"
												 :loading="dropDowns.product.loading"
												 :close-on-select="true"
												 label="name"
												 track-by="id"
												 :custom-label="fullName"
												 @search-change="fetchEmployees($event)"
												 :placeholder="$t('incomes.create.select-employee')">

										<template slot="singleLabel" slot-scope="props">
											{{ props.option.firstName }}
										</template>
									</multiselect>
									<b-button class="pull-right" @click="dropDowns.employees.responsible2 = null"
											  style="position: absolute; right:6px" size="sm" variant="light">x
									</b-button>
									<div class="clearfix"></div>

								</b-form-group>
							</b-col>
							<b-col cols="6">
								<b-form-group
									breakpoint="lg"
									label-size="sm"
									label-cols="4"
									:label="$t('incomes.create.initiator')"
									label-for="refName"
									class="required mb-1"
								>
									<multiselect class="pull-left with-clear" v-model="dropDowns.employees.initiator"
												 :options="employees"
												 :searchable="true"
												 :selectLabel="''"
												 deselectLabel="''"
												 :loading="dropDowns.product.loading"
												 :close-on-select="true"
												 label="name"
												 track-by="id"
												 :custom-label="fullName"
												 @search-change="fetchEmployees($event)"
												 :placeholder="$t('incomes.create.initiator')">

										<template slot="singleLabel" slot-scope="props">
											{{ props.option.firstName }}
										</template>
									</multiselect>
									<b-button class="pull-right" @click="dropDowns.employees.initiator = null"
											  style="position: absolute; right:6px" size="sm" variant="light">x
									</b-button>
									<div class="clearfix"></div>
								</b-form-group>
							</b-col>

						</b-row>
					</div>
				</b-collapse>
			</div>-->
			<!-- IF MODE IS CREATE -->
			<create-items
				:document-id="formtItem.id"
				:section="section"
				:items="formtItem.whItems"
				@success="addItem"
				@changeRowVariant="changeRowVariant"
				:allTotalCount="allTotalCount"
				:incomeTotal="incomeTotal"
				:priceTotal="priceTotal"
				:department="departmentId"
				:toDepartmentId="formtItem.toDepartmentId"
				:currency-rate="currencyRate"
				:depCurrencyName="depCurrencyName"
				v-if="$can('create', 'warehouse-document-item')"
			></create-items>

			<!-- IF MODE EDIT (DO NOT SHOW PERMENANTLY HIDED 04.06.2019) -->
			<!--<create-items
				:document-id="formtItem.id"
				:section="section"
				@success="addItem"
				:currency-rate="currencyRate"
				:department="formtItem.fromDepartmentId"
				:toDepartmentId="formtItem.toDepartmentId"
				v-if="$can('edit', 'warehouse-document-item') && mode !== 'edit'"
			></create-items>-->
			<ItemList
				v-if="showItems"
				:items="formtItem.whItems"
				@remove="removeItem"
				:mode="mode"
				:section="section"
				:depCurrencyName="depCurrencyName"
			></ItemList>
			<div class="text-center mb-3" v-if="!showItems">
				<b-spinner size="sm" variant="primary"></b-spinner>
			</div>
			<b-row>
				<b-col cols="3"></b-col>
				<b-col cols="9">
					<b-form-group
						breakpoint="lg"
						label-size="sm"
						label-cols="2"
						:label="$t('comment')"
						label-for="refName"
						class="required"
					>
						<b-form-textarea
							v-model="formtItem.comment"
							:placeholder="$t('comment')"
						></b-form-textarea>
					</b-form-group>
				</b-col>
			</b-row>
		</b-form>
		<div class="modal-actions">
			<b-row class="align-items-center">
				<b-col cols="6" class="mb-3 mb-xl-0">
					<b-row>
						<b-col cols="3">
							<b-button block size="sm" type="button" @click="cancelAndClearInventory"
									  variant="outline-danger">{{
								$t('cancel') }}
							</b-button>
						</b-col>
						<b-col cols="3" v-if="isKirim ||isTransfer">
							<b-button block :disabled="whDocSaveDisabled" type="button" size="sm" class="btn btn-warning" @click="storeSusPend(true)" variant="primary">
								{{ $t('save')}}
							</b-button>

						</b-col>
						<b-col cols="6">
							<b-button block :disabled="whDocSaveDisabled" type="button" class="btn btn-success"
									  size="sm" @click="store(true)"
									  variant="primary">{{ $t('warehouse.document.saveAndFinish') }}

							</b-button>
						</b-col>
					</b-row>
				</b-col>
			</b-row>
		</div>
		<!--<b-modal
			v-model="depWarning"
			hide-title="true"
			ref="depWarningModal"
			@ok="depWarningOk"
			@cancel="depWarningCancel"
			ok-title="Да"
			cancel-title="Отмена"
		>
			<h5>Вы изменили отдел, в этом случае удаляется все добавленные товары. Продолжать? </h5>
		</b-modal>-->
	</div>
</template>

<script>

    import Vue from 'vue';
    // import ContrAgentSelect from "../../../references/blocks/ContrAgentSelect";
    // import ContrAgentService from "../../../../services/contragent.service";
    import UsersService from "../../../../services/users.sevice";
    import WhDocument from "../../../../services/wh-document.service";
    import Multiselect from 'vue-multiselect'
    import ItemList from "./ItemList";
    import Employees from "../mixins/Employee";
    // import MaskedInput from 'vue-masked-input'
    import CreateItems from "./CreateItems";
    import CurrencyService from "../../../../services/currency.service";
    import {mapGetters, mapState, mapActions} from "vuex";
    import {validators} from "../mixins/validators";

    export default {
        name: 'CreateForm',

        mixins: [Employees, validators],

        components: {
            CreateItems,
            Multiselect,
            ItemList
        },
        props: {
            mode: {
                type: String,
                default: 'create'
            },
            /*section: {
                type: String,
                default: 'KIRIM'
            },*/
            editItem: {
                type: Object,
                default: null
            }
        },

        data: function () {
            return {
                sampleForAttrId: {
                    "field": "category.id",
                    "value": "",
                    "type": "long",
                    "option": "EQUALS",
                    "orderBy": "desc"
                },
                selectContrAgent: false,
                contragentsLoading: false,
                contrAgent: [],
                categoryOptions: {
                    items: [],
                    value: null
                },
                groupOptions: {
                    items: [],
                    value: null
                },
                tempForSale: {
                    'action': 'OPTOM_SAVDO',
                },
                section: 'KOCHIRISH',
                item: {
                    id: null,
                    comment: null,
                    action: 'KIRIM',
                    documentType: 'NAKLADNOY',
                    fromDepartmentId: null,
                    fromDepartmentName: null,
                    toDepartmentId: null,
                    toDepartmentName: null,
                    fromEmployeeId: null,
                    fromEmployeeName: null,
                    toEmployeeId: null,
                    toEmployeeName: '',
                    responsible1Id: null,
                    responsible1Name: '',
                    responsible2Id: null,
                    responsible2Name: '',
                    regNumber: '',
                    regDate: null,
                    contragentId: null,
                    contragentName: '',
                    reason: null,
                    initiatorId: null,
                    fromCurrencyRate: null,
                    toCurrencyRate: null,
                    whItems: []
                },
                depWarning: false,
                toDepartmentForCurrency: {
                    currencyName: ''
                },
                fromDepartmentForCurrency: {
                    currencyName: ''
                },
                toggleCurrencyInputs: false,
                oldFromDepId: null,
                depCurrencyName: '',
                allTotalCount: 0,
                x: false,
                incomeTotal: 0,
                priceTotal: 0,
                dropDowns: {
                    counterparties: {
                        items: [],
                        value: null
                    },
                    department: {
                        items: [],
                        value: null
                    },
                    transferPermittedDepartments: [],
                    product: {
                        items: [],
                        value: null,
                        loading: false,
                        search: {
                            page: 1,
                            limit: 10,
                            attributes: [{
                                field: 'name',
                                value: '',
                                option: 'CONTAINS'
                            }]
                        }
                    },
                    units: {
                        items: [],
                        value: null
                    },
                    provider: {
                        items: [],
                        value: null
                    },
                    employees: {
                        from: null,
                        to: null,
                        responsible: null,
                        responsible2: null,
                        initiator: null
                    }
                },
                currencyRate: -1,
                showItems: true,
                foundIndexOfFromDep: -1
            }
        },

        methods: {
            ...mapActions('contragents', [
                'fetchContragents',
                'setCurrentPage', // receives currentPage
                'setParamForFilter', // receives fieldObj
                'deleteParamFromFilter', // receives fieldName
                'resetParamForFilter', // receives nothing; just call and it resets the filter
                'deleteContragentStore',
                'createContragentStore',
                'changeFieldsForTable'
            ]),
            ...mapActions('references', [
                'getReferenceChildren',
            ]),
            async getContragentsForWholesale() {
                await this.getReferenceChildren('CONTRAGENT_CATEGORY');
                this.categoryOptions = Object.assign({}, this.getCategoryChildren);
            },
            /* CATEGORY FILTER FUNC */
            async categoryFilterChanged(categoryId) {
                let fieldName = 'category.id';
                if (categoryId) {
                    this.sampleForAttrId.field = fieldName;
                    this.sampleForAttrId.value = categoryId;

                    this.deleteParamFromFilter(fieldName);
                    let fieldObj = Object.assign({}, this.sampleForAttrId);
                    this.setParamForFilter(fieldObj);
                } else {
                    if (!this.groupOptions.value) {
                        this.resetParamForFilter();
                    } else {
                        this.deleteParamFromFilter(fieldName);
                    }
                }
                // GET FILTERED DATA
                this.contragentsLoading = true;
                await this.fetchContragents('pos');
                this.contragentsLoading = false;
            },
            /* CLEARING FILTER */
            clearCategoryFilter() {
                this.categoryOptions.value = null;
            },
            ...mapActions('pos', [
                'getItemsForPos', 'increaseCount', 'addToCartAction', 'setIncrementValue',
                'decreaseCount', 'deleteFromCartAction', 'saleFinish', 'createPosDraft',
                'editDraft', 'getLatestSuspends', 'suspendSale', 'setSaleItemForDiscountModal', 'setSusPendClient', 'setErrorOccurNotHappen', 'editDraftOptom'
            ]),
            ...mapActions('warehouse', [
                'clearInventoryList'
            ]),
            depWarningOk() {
                this.depWarning = false;
                this.$refs.depWarningModal.hide();
                this.formtItem.whItems.forEach((item, index) => {
                    let foundIndex = this.formtItem.whItems.findIndex(el => {
                        return el.id = item.id
                    });
                    let newDepId = this.formtItem.fromDepartmentId;
                    this.formtItem.fromDepartmentId = this.oldFromDepId;
                    WhDocument.removeItem(this.formtItem).then(() => {
                        this.formtItem.whItems.splice(foundIndex, 1);
                        this.formtItem.fromDepartmentId = newDepId;
                    });
                });
            },
            depWarningCancel() {
                this.formtItem.fromDepartmentId = this.oldFromDepId;
                this.depWarning = false;
                this.$refs.depWarningModal.hide();
            },
            async cancel() {
                this.$store.commit('warehouse/setWhDocDisabled', false);
                this.$emit('close', true);
            },
            async cancelAndClearInventory() {
                /*let payload = {
					docuementId: this.formtItem.id,
					departmentId: this.formtItem.fromDepartmentId,
					items:this.formtItem.whItems
				}*/
                /*await this.clearInventoryList(this.formtItem);
                this.$store.commit('warehouse/setWhDocDisabled', false);
                this.$emit('docSuspended', 'forTransfer');*/
                this.$emit('close', true);
            },

            /**
             *
             */
            /*fetchList() {
                ContrAgentService.search({
                    page: 1, limit: 700
                }).then(response => {
                    this.dropDowns.counterparties.items = response.data.items;
                })
            },*/

            /**
             *
             */
            fetchPermissions() {
                if (this.$can('get', 'permitted departments')) {
                    UsersService.getPermittedDepartments().then(response => {
                        this.dropDowns.department.items = response.data.permittedDepartments;
                        this.dropDowns.transferPermittedDepartments = response.data.transferPermittedDepartments
                    })
                }
            },

            /**
             * Store Warehouse document
             */
            storeSusPend(update = false) {
                this.$store.commit('warehouse/setWhDocDisabled', true);
                if (!update) {
                    this.setDocType();
                    WhDocument.store(this.formtItem).then(response => {
                        this.formtItem.id = response.data.id;
                        if (response.data.regNumber) {
                            this.formtItem.regNumber = response.data.regNumber
                        }
                        if (response.data.regDate) {
                            this.formtItem.regDate = response.data.regDate
                        }
                        this.$store.commit('warehouse/setWhDocDisabled', false);
                    }).catch(error => {
                        this.$store.commit('warehouse/setWhDocDisabled', false);
                    });
                } else {
                    this.$validator.validate().then(valid => {
                        if (valid && this.formtItem.whItems.length > 0) {
                            let countErrorIndex = this.formtItem.whItems.findIndex(el => {
                                return el.count <= 0;
                            });
                            if (countErrorIndex > -1) {
                                this.$vs.notify({
                                    title: "Количество",
                                    text: 'Проверьте количество товаров!',
                                    color: 'warning',
                                    icon: 'close',
                                    position: 'top-right'
                                });
                                this.$store.commit('warehouse/setWhDocDisabled', false);
                                return 0;
                            }
                            if (this.isTransfer) {

                                if (this.formtItem.toDepartmentId) {
                                    let countErrorArray = [];
                                    this.formtItem.whItems.forEach((item, index) => {
                                        if (item.count > item.realBalance) {
                                            this.x = true;
                                            Vue.set(item, '_rowVariant', 'danger');
                                            let tempArr = [{
                                                index: index,
                                                item: item
                                            }];
                                            countErrorArray = [...countErrorArray, ...tempArr];
                                        }
                                    })
                                    for (let i = 0; i < this.formtItem.whItems.length; i++) {
                                        for (let j = 0; j < countErrorArray.length; j++) {
                                            this.formtItem.whItems.splice(countErrorArray[j].index, 1)
                                        }
                                    }
                                    for (let j = 0; j < countErrorArray.length; j++) {
                                        this.formtItem.whItems.unshift(countErrorArray[j].item);
                                    }
                                    if (!this.x) {
                                        if (this.formtItem.toCurrencyRate == '') {
                                            this.formtItem.toCurrencyRate = null;
                                        } else if (this.formtItem.fromCurrencyRate == '') {
                                            this.formtItem.fromCurrencyRate = null;
                                        }
                                        this.formtItem.documentStatus = 'SUSPENDED';
                                        WhDocument.editTransferNew(this.formtItem).then(response => {
                                            this.formtItem.id = response.data.id;
                                            // this.$emit('redirect', response.data.id);
                                            this.cancel();
                                            this.$emit('docSuspended', 'forTransfer');
                                        }).catch(error => {
                                            this.$store.commit('warehouse/setWhDocDisabled', false);
                                        });
                                        return;
                                    } else {
                                        this.x = false;
                                        this.$vs.notify({
                                            title: this.$t('words.error'),
                                            text: 'Проверьте количество товара!',
                                            color: 'danger',
                                            icon: 'close',
                                            position: 'top-right'
                                        })
                                        this.$store.commit('warehouse/setWhDocDisabled', false);
                                        return;
                                    }
                                } else {
                                    this.$vs.notify({
                                        title: "Выберите Подразделение (Получатель)",
                                        color: 'warning',
                                        icon: 'close',
                                        position: 'top-right'
                                    });
                                    this.$store.commit('warehouse/setWhDocDisabled', false);
                                    return 0;
                                }
                            }
                            this.formtItem.documentStatus = 'SUSPENDED';

                            WhDocument.update(this.formtItem).then(response => {
                                this.formtItem.id = response.data.id;
                                this.$emit('docSuspended', 'forIncome');
                                this.cancel();
                                this.$vs.notify({
                                    text: 'Документ успешно сохранен',
                                    color: 'success',
                                    icon: 'close',
                                    position: 'top-right'
                                })
                            }).catch(error => {
                                this.$vs.notify({
                                    title: this.$t('words.error'),
                                    text: 'Пожалуйста, проверьте все поле еще раз',
                                    color: 'danger',
                                    icon: 'close',
                                    position: 'top-right'
                                })
                                this.$store.commit('warehouse/setWhDocDisabled', false);
                            });
                        } else {

                            Object.keys(this.validationFields).some(key => {
                                this.validationFields[key].touched = true;
                                this.validationFields[key].dirty = true;
                                this.validationFields[key].changed = true;
                            });

                            this.$vs.notify({
                                title: this.$t('words.error'),
                                text: 'Заполните все обязательное поле',
                                color: 'danger',
                                icon: 'close',
                                position: 'top-right'
                            })
                            this.$store.commit('warehouse/setWhDocDisabled', false);
                        }
                    }).catch(error => {
                        this.$vs.notify({
                            title: this.$t('words.error'),
                            text: 'Пожалуйста, проверьте все поле еще раз',
                            color: 'danger',
                            icon: 'close',
                            position: 'top-right'
                        })
                        this.$store.commit('warehouse/setWhDocDisabled', false);
                    })
                }
            },


            store(update = false) {
                this.$store.commit('warehouse/setWhDocDisabled', true);
                if (!update) {
                    this.setDocType();
                    WhDocument.store(this.formtItem).then(response => {
                        this.formtItem.id = response.data.id;
                        if (response.data.regNumber) {
                            this.formtItem.regNumber = response.data.regNumber
                        }
                        if (response.data.regDate) {
                            this.formtItem.regDate = response.data.regDate
                        }
                        this.$store.commit('warehouse/setWhDocDisabled', false);
                    }).catch(error => {
                        this.$store.commit('warehouse/setWhDocDisabled', false);
                    });
                } else {
                    this.$validator.validate().then(valid => {
                        if (valid && this.formtItem.whItems.length > 0) {
                            let countErrorIndex = this.formtItem.whItems.findIndex(el => {
                                return el.count <= 0;
                            });
                            if (countErrorIndex > -1) {
                                this.$vs.notify({
                                    title: "Количество",
                                    text: 'Проверьте количество товаров!',
                                    color: 'warning',
                                    icon: 'close',
                                    position: 'top-right'
                                });
                                this.$store.commit('warehouse/setWhDocDisabled', false);
                                return 0;
                            }

                            if (this.isTransfer) {

                                if (this.formtItem.toDepartmentId) {
                                    let countErrorArray = [];
                                    this.formtItem.whItems.forEach((item, index) => {
                                        if (item.count > item.realBalance) {
                                            this.x = true;
                                            Vue.set(item, '_rowVariant', 'danger');
                                            let tempArr = [{
                                                index: index,
                                                item: item
                                            }];
                                            countErrorArray = [...countErrorArray, ...tempArr];
                                        }
                                    })
                                    for (let i = 0; i < this.formtItem.whItems.length; i++) {
                                        for (let k = 0; k < countErrorArray.length; k++) {
                                            this.formtItem.whItems.splice(countErrorArray[k].index, 1)
                                        }
                                    }
                                    for (let j = 0; j < countErrorArray.length; j++) {
                                        this.formtItem.whItems.unshift(countErrorArray[j].item);
                                    }
                                    if (!this.x) {
                                        if (this.formtItem.toCurrencyRate == '') {
                                            this.formtItem.toCurrencyRate = null;
                                        } else if (this.formtItem.fromCurrencyRate == '') {
                                            this.formtItem.fromCurrencyRate = null;
                                        }
                                        this.formtItem.documentStatus = 'READY';
                                        WhDocument.editTransferNew(this.formtItem).then(response => {
                                            this.formtItem.id = response.data.id;
                                            this.$emit('redirect', response.data.id);
                                            this.cancel();
                                        }).catch(error => {
                                            this.$store.commit('warehouse/setWhDocDisabled', false);
                                        });
                                        return;
                                    } else {
                                        this.$vs.notify({
                                            title: this.$t('words.error'),
                                            text: 'Проверьте количество товара!',
                                            color: 'danger',
                                            icon: 'close',
                                            position: 'top-right'
                                        })
                                        this.$store.commit('warehouse/setWhDocDisabled', false);
                                        return;
                                    }
                                } else {
                                    this.$vs.notify({
                                        title: "Выберите Подразделение (Получатель)",
                                        color: 'warning',
                                        icon: 'close',
                                        position: 'top-right'
                                    });
                                    this.$store.commit('warehouse/setWhDocDisabled', false);
                                    return 0;
                                }
                            }
                            this.formtItem.documentStatus = 'READY';
                            WhDocument.update(this.formtItem).then(response => {
                                this.formtItem.id = response.data.id;
                                this.$emit('redirect', response.data.id);
                                this.cancel();
                            }).catch(error => {
                                this.$vs.notify({
                                    title: this.$t('words.error'),
                                    text: 'Пожалуйста, проверьте все поле еще раз',
                                    color: 'danger',
                                    icon: 'close',
                                    position: 'top-right'
                                })
                                this.$store.commit('warehouse/setWhDocDisabled', false);
                            });
                        } else {

                            Object.keys(this.validationFields).some(key => {
                                this.validationFields[key].touched = true;
                                this.validationFields[key].dirty = true;
                                this.validationFields[key].changed = true;
                            });

                            this.$vs.notify({
                                title: this.$t('words.error'),
                                text: 'Заполните все обязательное поле',
                                color: 'danger',
                                icon: 'close',
                                position: 'top-right'
                            })
                            this.$store.commit('warehouse/setWhDocDisabled', false);
                        }
                    }).catch(error => {
                        this.$vs.notify({
                            title: this.$t('words.error'),
                            text: 'Пожалуйста, проверьте все поле еще раз',
                            color: 'danger',
                            icon: 'close',
                            position: 'top-right'
                        })
                        this.$store.commit('warehouse/setWhDocDisabled', false);
                    })
                }
            },

            setDocType() {
                if (this.isChiqim || this.isTransfer) {
                    this.formtItem.documentType = 'AKT';
                }
                if (this.isOff) {
                    this.formtItem.documentType = 'PROTOKOL';
                }
            },

            /**
             *  Add Warehouse item
             */
            async addItem($event) {
                /*if (this.mode === 'edit') {
					this.showItems = false;
					this.loadWhItems(this.formtItem.id)
				}*/
                let findIndex = this.formtItem.whItems.findIndex(el => {
                    return el.itemId == $event.itemId;
                });
                if (findIndex >= 0) {
                    if ($event.priceUzs || $event.incomingPriceUzs) {
                        this.formtItem.whItems[findIndex].count = parseInt(this.formtItem.whItems[findIndex].count) + parseInt($event.count);
                        this.formtItem.whItems[findIndex].incomingPriceUzs = $event.incomingPriceUzs ? $event.incomingPriceUzs : this.formtItem.whItems[findIndex].incomingPriceUzs;
                        this.formtItem.whItems[findIndex].priceUzs = $event.priceUzs ? $event.priceUzs : this.formtItem.whItems[findIndex].priceUzs;
                        let temp = this.formtItem.whItems[findIndex];
                        if (temp._rowVariant) {
                            if (temp._rowVariant == 'primary') {
                                temp._rowVariant = 'warning';
                            } else if (temp._rowVariant == 'warning') {
                                temp._rowVariant = 'success';
                            } else if (temp._rowVariant == 'success') {
                                temp._rowVariant = 'warning';
                            } else {
                                temp._rowVariant = 'warning';
                            }
                        } else {
                            temp._rowVariant = 'warning'
                        }
                        this.formtItem.whItems.forEach((el, index) => {
                            if (index !== findIndex) {
                                delete el['_rowVariant'];
                            }
                        });
                        this.formtItem.whItems.splice(findIndex, 1);
                        this.formtItem.whItems.unshift(temp);
                    } else {
                        this.formtItem.whItems[findIndex].count = parseInt(this.formtItem.whItems[findIndex].count) + parseInt($event.count);
                        let temp = this.formtItem.whItems[findIndex];
                        if (temp._rowVariant) {
                            if (temp._rowVariant == 'primary') {
                                temp._rowVariant = 'warning';
                            } else if (temp._rowVariant == 'warning') {
                                temp._rowVariant = 'success'
                            } else if (temp._rowVariant == 'success') {
                                temp._rowVariant = 'warning'
                            }
                        } else {
                            temp._rowVariant = 'warning'
                        }
                        this.formtItem.whItems.forEach((el, index) => {
                            if (index !== findIndex) {
                                delete el['_rowVariant'];
                            }
                        });
                        this.formtItem.whItems.splice(findIndex, 1);
                        this.formtItem.whItems.unshift(temp);
                    }
                } else {
                    this.formtItem.whItems.forEach(el => {
                        delete el['_rowVariant'];
                    });
                    $event._rowVariant = 'primary';
                    $event.realBalance = this.balance;
                    this.formtItem.whItems.unshift($event);
                }
                this.$vs.notify({
                    time: 1500,
					title: this.$t('add-product'),
                    color: 'success',
                    icon: 'close',
                    position: 'top-right'
                });
            },
            changeRowVariant(findIndex) {
                let temp = this.formtItem.whItems[findIndex];
                /*if (temp._rowVariant) {
					if (temp._rowVariant == 'primary') {
						temp._rowVariant = 'warning';
					} else if (temp._rowVariant == 'warning') {
						temp._rowVariant = 'success'
					} else if (temp._rowVariant == 'success') {
						temp._rowVariant = 'warning'
					}
				} else {
					temp._rowVariant = 'warning'
				}*/
                temp._rowVariant = 'danger'
                this.formtItem.whItems.forEach((el, index) => {
                    if (index !== findIndex) {
                        delete el['_rowVariant'];
                    }
                });
                this.formtItem.whItems.splice(findIndex, 1);
                this.formtItem.whItems.unshift(temp);
            },

            /**
             * Remove Warehouse item
             * @param $event
             */
            removeItem($event) {
                if (this.isTransfer) {
                    this.formtItem.whItems.splice($event, 1)
                    return 1;
                }
                WhDocument.removeItemId(this.formtItem, this.formtItem.whItems[$event].id).then(() => {
                    this.formtItem.whItems.splice($event, 1);
                });
            },

            setDropdowns() {
                this.dropDowns.counterparties.value = (this.editItem.contragentId) ? this.editItem.contragentId : null;

                this.dropDowns.employees.from = (this.editItem.fromEmployeeId) ? {
                    id: this.editItem.fromEmployeeId,
                    firstName: this.editItem.fromEmployeeName
                } : null;

                this.dropDowns.employees.to = (this.editItem.toEmployeeId) ? {
                    id: this.editItem.toEmployeeId,
                    firstName: this.editItem.toEmployeeName
                } : null;
                this.dropDowns.employees.responsible = (this.editItem.responsible1Id) ? {
                    id: this.editItem.responsible1Id,
                    firstName: this.editItem.responsible1Name
                } : null;
                this.dropDowns.employees.responsible2 = (this.editItem.responsible2Id) ? {
                    id: this.editItem.responsible2Id,
                    firstName: this.editItem.responsible2Name
                } : null;


            },

            async loadWhItems(documentId) {
                await WhDocument.byDocument(documentId).then(response => {
                    /**
                     * Hozirgi Javascript qoidalari bilan Vue js Objectdagi har qanday o'zgarishni Reactive seza olmaydi,
                     * shu sababdan Obyectga yangi property qo'shayotganda 'Vue.set' ishlatiladi (https://vuejs.org/v2/guide/reactivity.html#Change-Detection-Caveats).
                     */
                    Vue.set(this.formtItem, 'whItems', response.data);
                    // this.formtItem['whItems'] = response.data;
                    this.showItems = true;
                })
            },

            fullName({firstName, lastName, middleName}) {
                return `${firstName} ${lastName} ${middleName}`;
            },
        },

        async created() {
            await this.$store.commit('pos/resetState');
            await this.getContragentsForWholesale();
            /*window.addEventListener('beforeunload', (event) => {
                // event.returnValue = `Are you sure you want to leave?`;
                if (this.formtItem) {
                    if (this.formtItem.whItems.length > 0) {
                        this.cancelAndClearInventory();
                    }
                }
            });*/
        },
		beforeDestroy() {
		},
        async mounted() {
            /* FETCH CONTRAGENTS LIST */
            // this.fetchList();

            // this.fetchPermissions();
            /*if (this.mode === 'create') {
                this.item.action = this.section;
                this.store();
            } else {
                this.showItems = false;
                this.setDropdowns();
                CurrencyService.get(this.editItem.toDepartmentId).then(response => {
                    this.currencyRate = response.data;
                });
                await this.loadWhItems(this.editItem.id);
            }*/
        },

        watch: {
            /*contrAgent: {
                handler(newValue) {
                    this.selectContrAgent = newValue === null;
                }
            },*/
            /* WATCHERS FOR FILTER BEGIN */
            'categoryOptions.value': {
                handler(newVal) {
                    if (!newVal) {
                        this.categoryFilterChanged(null);
                    }
                    this.contrAgent = null
                }
            },
            'dropDowns.department.items': {
                deep: true,
                handler(newValue) {
                    if (this.mode !== 'create' && newValue) {
                        if (this.isKirim) {
                            let fromDepTemp = this.dropDowns.department.items.find(item => {
                                return item.id == this.editItem.toDepartmentId;
                            });
                            this.depCurrencyName = fromDepTemp ? fromDepTemp.currencyName : this.userDepCurrencyName;
                        } else {
                            let fromDepTemp = this.dropDowns.department.items.find(item => {
                                return item.id == this.editItem.fromDepartmentId;
                            });
                            this.depCurrencyName = fromDepTemp ? fromDepTemp.currencyName : this.userDepCurrencyName;
                        }
                    }
                }
            },
            'dropDowns.employees.to': {
                handler(newValue) {
                    if (!newValue) {
                        return false;
                    }
                    this.formtItem.toEmployeeId = newValue.id
                }
            },
            'dropDowns.employees.from': {
                handler(newValue) {
                    if (!newValue) {
                        return false;
                    }
                    this.formtItem.fromEmployeeId = newValue.id
                }
            },
            'dropDowns.employees.responsible': {
                handler(newValue) {
                    if (!newValue) {
                        return false;
                    }
                    this.formtItem.responsible1Id = newValue.id
                }
            },
            'dropDowns.employees.responsible2': {
                handler(newValue) {
                    if (!newValue) {
                        return false;
                    }
                    this.formtItem.responsible2Id = newValue.id
                }
            },
            'dropDowns.employees.initiator': {
                handler(newValue) {
                    if (!newValue) {
                        return false;
                    }
                    this.formtItem.initiatorId = newValue.id
                }
            },

            'formtItem.whItems': {
                deep: true,
                handler() {
                    this.allTotalCount = 0;
                    this.incomeTotal = 0;
                    this.priceTotal = 0;
                    if (this.formtItem.whItems) {
                        this.formtItem.whItems.forEach(item => {
                            this.incomeTotal += item.incomingPriceUzs ? item.incomingPriceUzs * item.count : 0;
                            this.priceTotal += item.priceUzs ? item.priceUzs * item.count : 0;
                            this.allTotalCount += item.count;
                        })
                    }
                }
            },
            'formtItem.toDepartmentId': {
                deep: true,
                handler(newValue) {
                    this.toDepartmentForCurrency = this.dropDowns.department.items.find(item => {
                        return item.id == newValue;
                    })
                    if (this.isKirim) {
                        this.depCurrencyName = this.toDepartmentForCurrency.currencyName;
                        CurrencyService.get(newValue).then(response => {
                            this.currencyRate = response.data;
                        })
                    } else if (this.isTransfer) {

                    }
                }
            },
            'formtItem.fromDepartmentId': {
                deep: true,
                handler(newVal, oldVal) {
                    this.fromDepartmentForCurrency = this.dropDowns.department.items.find(item => {
                        return item.id == newVal;
                    });
                    this.depCurrencyName = this.fromDepartmentForCurrency.currencyName;
                    this.depWarning = false;
                    if (oldVal && this.oldFromDepId && newVal !== this.oldFromDepId && this.formtItem.whItems.length > 0) {
                        this.oldFromDepId = oldVal;
                        this.depWarning = true;
                        this.$refs.depWarningModal.show();
                    }
                    if (this.isTransfer) {

                    }
                }
            },
            toggleCurrencyInputs: {
                handler(newVal) {
                    if (newVal) {
                        this.formtItem.fromCurrencyRate = 1;
                        this.formtItem.toCurrencyRate = null;
                    } else {
                        this.formtItem.toCurrencyRate = 1;
                        this.formtItem.fromCurrencyRate = null;
                    }
                }
            }
        },

        computed: {
            ...mapGetters('references', [
                'getCategoryChildren'
            ]),
            ...mapGetters('contragents', [
                'getContragentsForPos'
            ]),
            ...mapState('pos', [
                'totalCount', 'totalSum', 'checkPage', 'finalTotalSum', 'realTotalSum', 'comment',
                'shopName', 'currentSaleNumber',
                'currentSaleId',
                'shopAddress', 'cashierFullName', 'currentSellerName','sellerId',
                'currentSuspendId', 'currentSaleSuspendNumber', 'lastSuspendedSaleNumber', 'saleItemForDiscountModal', 'discount', 'customPromotion', 'errorOccur',
                'searchLoading', 'saleFinishError', 'saleFinishLoading',
                'isReturn'
            ]),
            ...mapState(['userDepCurrencyName']),
            ...mapGetters('warehouse', ['wTypes']),
            ...mapState('warehouse', ['whDocSaveDisabled']),
            ...mapState('warehouse', ['balance',]),
            isCurrenciesDifferent() {
                if (this.toDepartmentForCurrency.id && this.fromDepartmentForCurrency.id) {
                    if (!this.toggleCurrencyInputs) {
                        this.formtItem.fromCurrencyRate = 1;
                        this.formtItem.toCurrencyRate = null;
                    } else {
                        this.formtItem.fromCurrencyRate = null;
                        this.formtItem.toCurrencyRate = 1;
                    }
                    return this.toDepartmentForCurrency.currencyId !== this.fromDepartmentForCurrency.currencyId;
                } else {
                    return false;
                }
            },
            formtItem() {
                if (this.mode === 'create') {
                    return this.item;
                } else {
                    return this.editItem;
                }

            },
            depWarningComputed() {
                return this.depWarning;
            },
            isChiqim() {
                return this.section === 'CHIQIM';
            },
            isOff() {
                return this.section === 'SPISAT';
            },

            isTransfer() {
                return this.section === 'KOCHIRISH';
            },

            isKirim() {
                return this.section === 'KIRIM';
            },
            departments() {
                const departments = [];
                this.dropDowns.department.items.map(item => {
                    if (this.wTypes.includes(item.typeName))
                        departments.push({
                            value: item.id,
                            text: `${item.name} ${(item.parentName) ? '-' + item.parentName : ''}`
                        });
                });
                if (this.formtItem.fromDepartmentId) {
                    this.foundIndexOfFromDep = departments.findIndex(el => el.value == this.formtItem.fromDepartmentId);
                } else {
                    this.foundIndexOfFromDep = -1;
                }
                return departments;
            },
            toDepartments() {
                const departments = [];
                this.dropDowns.transferPermittedDepartments.map(item => {
                    if (this.wTypes.includes(item.typeName))
                        departments.push({value: item.id, text: `${item.name} - ${item.parentName}`});
                });
                if (this.foundIndexOfFromDep !== -1) {
                }
                return departments;
            },

            departmentId() {
                return (this.isKirim) ? this.formtItem.toDepartmentId : this.formtItem.fromDepartmentId;
            }

        }
    }
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style scoped lang="scss">
	.fromCurrencyRateId + div {
		padding: 0 !important;
	}
	.goods-form-wrapper-wholesale {
		min-height: 39rem;
		display: flex;
		flex-direction: column;
		padding-bottom: 0.5rem;
		.form-wholesale {
			margin-bottom: auto;
		}
		.modal-actions {
			margin-top: auto;
		}
	}
</style>
